/**
 * Brand design tokens.
 *
 * Single source of truth for the brand-primary indigo used across billing
 * surfaces (dunning banners, renewal/reactivate modals, plan tags, expired
 * full-page block).
 *
 * Aligned with the marketing site (#4F46E5) so users see one consistent
 * brand colour from pricing page → in-app upgrade flow → checkout return.
 *
 * Note: CLAUDE.md historically listed the design-token primary as #6366F1
 * (a sibling indigo, ~one shade lighter). The two are visually close but
 * not identical; the dunning flow standardises on #4F46E5 to match the
 * marketing site. Update CLAUDE.md if the broader app migrates too.
 */
export const BRAND_PRIMARY = '#4F46E5';
export const BRAND_ACCENT = '#7C3AED';
